var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9735 0.760146C24.8457 0.225362 24.258 -0.138522 23.7251 0.0506206C23.7251 0.0506206 0.638552 8.1972 0.634711 8.20008C0.280361 8.33162 0.0201199 8.66958 0.000913972 9.0565C-0.0163714 9.42807 0.21314 9.81499 0.552125 9.97245L9.49442 14.1461C9.49442 14.1461 13.8513 9.79003 13.859 9.78235C14.7232 8.91825 16.1032 10.2547 15.2168 11.14L10.8523 15.5037C10.8523 15.5037 15.0209 24.4347 15.0286 24.4491C15.1986 24.7755 15.5309 24.9829 15.8958 24.9992C16.2924 25.0175 16.6592 24.7141 16.8013 24.3588C16.8013 24.3588 24.9447 1.29013 24.9495 1.27573C25.01 1.10963 25.0138 0.930086 24.9735 0.760146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoney);
export default __webpack_public_path__ + "static/media/send-money.f6ca0edccaff07f7ac3994d097533770.svg";
export { ForwardRef as ReactComponent };